module.exports = __webpack_public_path__ + "img/notification-text.670c9de3.svg";